<template>
  <div>
    <List v-if="invoices"
      class="list eapps-invoices-list"
      :fields=fields
      :items=invoices
      :url=itemurl
     />
    <Pages v-model="p" :pages=pages />
    <Loading v-if="loading" class="absolute" />
  </div>
</template>

<script>
  import {withapptoken} from '@/helpers/mixins/pagination'
  import List from '@/helpers/components/display/List.vue'
  import {billings as invoice_fields} from '../fieldstwo'
  import invoices_mixin from '../invoices'
  import _ from 'lodash'

  export default {
    mixins: [withapptoken, invoices_mixin],
    components: {List},
    data () {
      //fields
      var fields = _.pick(invoice_fields, [
        'company_name', 'invoice_number', 'cost_clean', 'cost_tax', 'cost_final', 'invoice_date', 'billing_status'
      ]);
      fields.billing_status = this.$fields.entry(fields.billing_status, 'billing_status');
      fields.billing_status.function = (item, el) =>
        el(
          'span',
          {class: 'status ' + item.billing_status},
          [this.$t('billings:invoices.status.' + item.billing_status)]
        )
      ;

      //Payment field
      // fields.pay = {
      //   url: false,
      //   label: '',
      //   function: (item, el) => {
      //     var link, text;
      //     if (Number(item.invoice) === 2) {
      //       return '';
      //     }
      //     if (item.billing_status === 'paid') {
      //       link = {name: 'billings.invoices.transactions', params:{id:item.id}};
      //       text = this.$i18n.t('billings:view_transactions');
      //     } else {
      //       link = item.payment_link;
      //       text = this.$i18n.t('billings:pay_with_pp');
      //     }
      //     if (link === 'manual') {
      //       return el('button', {
      //         class: 'btn inverse',
      //         attrs: {type: 'button'},
      //         on: {click: () => this.payManual(item.id)},
      //       }, [text]);
      //     }
      //     if (typeof link === 'string') {
      //       if (!link) {return '';}
      //       return el(
      //         'a', {
      //           attrs: {href: link},
      //           class: 'btn',
      //         }, [text]
      //       );
      //     } else if (typeof link === 'object') {
      //       return el(
      //         'router-link', {
      //           props: {to: link},
      //           class: 'btn inverse',
      //         }, [text]
      //       );
      //     }
      //     return '';
      //   }
      // };

      fields.pay = {
        url: false,
        label: '',
        function: (item, el) => {
          var link, text;
          if (Number(item.invoice) === 2) {
            return '';
          }
          link = {name: 'admin.invoicesdetail.transaction', params:{id:item.id}};
          text = this.$i18n.t('billings:download');
          if (link === 'manual') {
            return el('button', {
              class: 'btn inverse',
              attrs: {type: 'button'},
              on: {click: () => this.payManual(item.id)},
            }, [text]);
          }
          if (typeof link === 'string') {
            if (!link) {return '';}
            return el(
              'a', {
                attrs: {href: link},
                class: 'btn',
              }, [text]
            );
          } else if (typeof link === 'object') {
            return el(
              'router-link', {
                props: {to: link},
                class: 'btn inverse',
              }, [text]
            );
          }
          return '';
        }
      };

      return {
        fields,
        loading: false,
        asynclisturl: (apptoken) => 'billings?' +
          'filter=invoice::neq::0,' +
          'apptokens_id::eq::' + this.$route.params.id + '&' +
          'include=billings_transactions,billings_contracts&' +
          'sort=invoice_date::desc',
        itemurl: (item) => {
          if (item.invoice_number) {
            return {name: 'admin.invoicesdetail.transaction', params:{id:item.id}};
          } else {
            return false;
          }
        },
      };
    },
    computed: {
      invoices () {
        if (this.asynclist) {
          return this.asynclist.list.map(this.compute);
        }
      },
    },
    methods: {
      payManual (id) {
        this.loading = true;
        return this.api.post('billings/invoice/pay_manual/' + id)
          .then(() => this.api.get('billings/' + id + '?include=billings_transactions'))
          .then(billing => billing.billings_transactions.filter(t => t.approval_link))
          .then(transactions => {
            if (!transactions || !transactions.length) {
              throw new Error('Cannot get payment link');
            }
            window.location = transactions.approval_link;
          })
          .then(() => this.reloadcount++)
          .toast(false)
          .finally(() => this.loading = false)
        ;
      }
    },
  }
</script>

<style lang="scss">
  .eapps-invoices-list {
    .btn {
      display: block;
      width: 100%;
    }
    /*.cell-cost_final dd {
      text-align: right;
      padding-right: 40px;
    }*/
    span.status {
      display: block;
      @include font-size(18px, 27px);
      font-weight: 700;
      padding: 0 5px;
      text-align: center;
      &.paid {
        background: $state-success;
        color: white;
      }
      &.pending {
        background: $state-warning;
      }
      &.not_paid {
        background: $state-error;
        color: white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/billings/components/Invoicestwo.vue